$(function() {
	$('[data-async]').each(function() {
		init(this);
	});

	function init(el) {
		var url = el.dataset.async;
		$(el).change(function(e) {
			var formData = new FormData();
			formData.append(el.name, el.value);
			fetch(url, {
				method: 'POST',
				body: formData
			})
				.then(function(response) {
					return response.json();
				})
				.then(function(response) {
					if (response.hasOwnProperty('action')) {
						takeAction(response.action);
					}
				}, function(error) {
					console.error(error);
				});
		});
	}

	function takeAction(action) {
		if ('refresh' === action) {
			location.reload();
		}
	}
});